// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  factionKey: __t.string().name("faction_key"),
  rank: __t.u32(),
  xp: __t.u64(),
  tokens: __t.u64(),
  arcStep: __t.u32().name("arc_step"),
  updatedAt: __t.timestamp().name("updated_at"),
});
